/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Step_Up_ConfirmInputs */

const id_staff_step_up_confirm = /** @type {(inputs: Staff_Step_Up_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfirmasi`)
};

const en_staff_step_up_confirm = /** @type {(inputs: Staff_Step_Up_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Staff_Step_Up_ConfirmInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_step_up_confirm = /** @type {((inputs?: Staff_Step_Up_ConfirmInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Step_Up_ConfirmInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_step_up_confirm(inputs)
	return id_staff_step_up_confirm(inputs)
});